import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

const MATCHER = /(?:[?&]|^)feature_toggle=([^&]*)/i;
const COOKIE_ID = 'feature_toggle';
const FeatureFlipContext = React.createContext([]);

function valueMatcher(str) {
  return v => v.toUpperCase() === str.toUpperCase();
}

function getStorage() {
  return Cookies.get(COOKIE_ID) ? Cookies.get(COOKIE_ID).split(',') : [];
}

function setStorage(location) {
  const match = location.search.match(MATCHER);
  if (!match) return;

  if (match[1].split(',').find(valueMatcher('false'))) {
    return Cookies.remove(COOKIE_ID);
  }

  return Cookies.set(
    COOKIE_ID,
    match[1]
      .split(',')
      .reduce(
        (acc, key) => (acc.find(valueMatcher(key)) ? acc : acc.concat(key)),
        Cookies.get(COOKIE_ID) ? Cookies.get(COOKIE_ID).split(',') : [],
      )
      .join(','),
  );
}

export class Provider extends Component {
  state = { keys: this.props.keys || [] };

  handleHistoryUpdate = location => {
    setStorage(location);
    this.updateState();
  };

  updateState = () => {
    this.setState(() => ({
      keys: getStorage(),
    }));
  };

  componentDidMount() {
    const { history } = this.props;
    setStorage(history.location);
    this.updateState();
    this.unlisten = history.listen(this.handleHistoryUpdate);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { children } = this.props;
    return (
      <FeatureFlipContext.Provider value={this.state.keys}>
        {children}
      </FeatureFlipContext.Provider>
    );
  }
}

Provider.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.object,
    listen: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const FeatureFlip = ({ name, children }) => (
  <FeatureFlipContext.Consumer>
    {values => {
      const feature = values.find(
        val => val.toUpperCase() === name.toUpperCase(),
      );

      if (typeof children === 'function') {
        return children(Boolean(feature));
      }

      return feature ? children : null;
    }}
  </FeatureFlipContext.Consumer>
);

FeatureFlip.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FeatureFlip;
